var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "multiplePeopleCaseList" } },
    [
      _c("c-header-return", {
        attrs: { isCustom: true },
        scopedSlots: _vm._u([
          {
            key: "customTitle",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "title-con-middle flex flex-center-1" },
                  [
                    _c("div", { staticClass: "flex flex-ver" }, [
                      _c("h1", { staticClass: "case-title" }, [
                        _vm._v("多人开箱"),
                      ]),
                      _c("img", {
                        staticClass: "case-title-rule-item",
                        attrs: {
                          src: require("../../../assets/images/help_fill.png"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.multiplePeople_cases_rules_show = true
                          },
                        },
                      }),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      !_vm.$screen.mobile
        ? _c("div", { staticClass: "user-tabs" }, [
            _c("ul", { staticClass: "user-tabs__list" }, [
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass: "user-tabs__btn",
                    class: { active: _vm.tabs == "all" },
                    on: {
                      click: function ($event) {
                        return _vm.switchTabs("all")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "battle.svg" },
                        }),
                        _c("div", [_vm._v("最近合开")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass: "user-tabs__btn user-tabs__btn--items",
                    class: { active: _vm.tabs == "mine" },
                    on: {
                      click: function ($event) {
                        return _vm.switchTabs("mine")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "battle.svg" },
                        }),
                        _c("div", [_vm._v("我的合开")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _c("li", { staticClass: "user-tabs__item" }, [
                _c(
                  "button",
                  {
                    staticClass: "user-tabs__btn user-tabs__btn--items",
                    class: { active: _vm.tabs == "history" },
                    on: {
                      click: function ($event) {
                        return _vm.switchTabs("history")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "user-tabs__btn-inner" },
                      [
                        _c("c-svg", {
                          staticClass: "user-tabs__btn-icon",
                          attrs: { src: "battle.svg" },
                        }),
                        _c("div", [_vm._v("历史合开")]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn-create",
                on: { click: _vm.openCreateNewCase },
              },
              [_vm._v("创建合开")]
            ),
          ])
        : _vm._e(),
      _vm.$screen.mobile
        ? _c(
            "div",
            {
              staticClass:
                "homeContainerItem-content-queryItem-all flex flex-center-1",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "homeContainerItem-content-queryItem flex flex-ver",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "category-items flex flex-ver",
                      class: { active: _vm.tabs == "all" },
                      on: {
                        click: function ($event) {
                          return _vm.switchTabs("all")
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "category-items-icon el-icon-menu",
                      }),
                      _c("p", [_vm._v("最近合开")]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "category-items flex flex-ver",
                      class: { active: _vm.tabs == "mine" },
                      on: {
                        click: function ($event) {
                          return _vm.switchTabs("mine")
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "category-items-icon el-icon-menu",
                      }),
                      _c("p", [_vm._v("我的合开")]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "category-items flex flex-ver",
                      class: { active: _vm.tabs == "history" },
                      on: {
                        click: function ($event) {
                          return _vm.switchTabs("history")
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "category-items-icon el-icon-menu",
                      }),
                      _c("p", [_vm._v("历史合开")]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "icon flex flex-center-1",
                  class: { "icon-active": _vm.isShowShaixuan },
                  on: { click: _vm.openCreateNewCase },
                },
                [_vm._v(" 创建合开 ")]
              ),
              _c("div", { staticClass: "shadow" }),
            ]
          )
        : _vm._e(),
      !_vm.$screen.mobile
        ? [
            _c("div", { staticClass: "battle__header flex flex-center-1" }, [
              _c(
                "div",
                { staticClass: "battle__header-item flex flex-center-1" },
                [_vm._v("局号")]
              ),
              _c(
                "div",
                {
                  staticClass: "battle__header-item-1",
                  class: {
                    gunListPCWidth: !_vm.$screen.mobile && _vm.tabs == "mine",
                    gunListPCWidth1: !_vm.$screen.mobile && _vm.tabs != "mine",
                  },
                },
                [_vm._v(" 合开盲盒 ")]
              ),
              _c(
                "div",
                { staticClass: "battle__header-item flex flex-center-1" },
                [_vm._v("状态")]
              ),
              _c(
                "div",
                { staticClass: "battle__header-item-2 flex flex-center-1" },
                [_vm._v("合开状态")]
              ),
              _vm.tabs == "mine"
                ? _c(
                    "div",
                    { staticClass: "battle__header-item flex flex-center-1" },
                    [_vm._v(" 我的份额 ")]
                  )
                : _vm._e(),
              _c("div", {
                staticClass: "battle__header-item flex flex-center-1",
              }),
              !_vm.$screen.mobile
                ? _c(
                    "div",
                    {
                      staticClass: "battle__header-item flex flex-center-1",
                      staticStyle: { border: "none" },
                    },
                    [_vm._v(" 结束时间 ")]
                  )
                : _vm._e(),
            ]),
            _c(
              "transition-group",
              {
                staticClass: "battle-table",
                attrs: { name: "multiplePeopleCaseList", tag: "div" },
              },
              _vm._l(_vm.multiplePeopleCaseList, function (caseItem) {
                return _c("c-list-item", {
                  key: _vm.tabs + "-" + caseItem.id,
                  attrs: { currentTab: _vm.tabs, item: caseItem },
                })
              }),
              1
            ),
          ]
        : _vm._e(),
      _vm.$screen.mobile
        ? [
            _c("div", { staticClass: "new-mobile-table" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "new-mobile-tableContent" },
                _vm._l(_vm.multiplePeopleCaseList, function (items, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "new-mobile-tableContent-item flex flex-ais flex-jcsb",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "tableContent-item-item width-1" },
                        [
                          _c("div", { staticClass: "juhao-text" }, [
                            _vm._v(_vm._s(_vm._f("addZero")(items.id))),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "tableContent-item-item width-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "baoxiang-item" },
                            [
                              items.cases
                                ? _vm._l(
                                    items.cases,
                                    function (caseItem, index) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "baoxiang-text flex flex-col flex-center-1",
                                        },
                                        [
                                          caseItem.picture
                                            ? _c("img", {
                                                attrs: {
                                                  src: _vm.$imgfilter(
                                                    caseItem.picture
                                                  ),
                                                },
                                              })
                                            : _vm._e(),
                                          _c("p", [
                                            _vm._v(_vm._s(caseItem.name)),
                                          ]),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "tableContent-item-item width-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "jiage-item flex flex-col flex-ver",
                            },
                            [
                              _c("div", { staticClass: "jiage-text" }, [
                                _vm._v(
                                  _vm._s(items.currAmount) +
                                    " / " +
                                    _vm._s(items.price)
                                ),
                              ]),
                              items.status == "0"
                                ? [
                                    _c("el-statistic", {
                                      staticClass: "countDown",
                                      attrs: {
                                        format: "HH:mm:ss",
                                        "value-style": {
                                          fontSize: "10px",
                                          color: "#F5B844",
                                        },
                                        value: items.endTime,
                                        "time-indices": "",
                                      },
                                    }),
                                  ]
                                : [
                                    _c("div", { staticClass: "status-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          [
                                            "已创建",
                                            "已打开",
                                            "未达标",
                                            "已取消",
                                            "打开中",
                                          ][items.status]
                                        )
                                      ),
                                    ]),
                                  ],
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "last-item flex flex-col flex-ver" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "btns-item flex flex-center-1",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleShowmultiplePeopleCaseDetail(
                                        items
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        items.status == "0"
                                          ? "进入"
                                          : items.status == "1"
                                          ? "已打开"
                                          : items.status == "4"
                                          ? "打开中"
                                          : "查看"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        : _vm._e(),
      _vm.tabs == "all"
        ? _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c("Page", {
                attrs: {
                  current: _vm.recentCaseParams.pageIndex,
                  total:
                    _vm.recentCaseParams.total >
                    _vm.recentCaseParams.pageSize * 5
                      ? _vm.recentCaseParams.pageSize * 5
                      : _vm.recentCaseParams.total,
                  "page-size": _vm.recentCaseParams.pageSize,
                },
                on: {
                  "update:current": function ($event) {
                    return _vm.$set(_vm.recentCaseParams, "pageIndex", $event)
                  },
                  "on-change": _vm.getMultiplePeopleCaseRecentListTemp,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.tabs == "mine"
        ? _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c("Page", {
                attrs: {
                  current: _vm.myCaseParams.pageIndex,
                  total:
                    _vm.myCaseParams.total > _vm.myCaseParams.pageSize * 10
                      ? _vm.myCaseParams.pageSize * 10
                      : _vm.myCaseParams.total,
                  "page-size": _vm.myCaseParams.pageSize,
                },
                on: {
                  "update:current": function ($event) {
                    return _vm.$set(_vm.myCaseParams, "pageIndex", $event)
                  },
                  "on-change": _vm.getMultiplePeopleCaseMineList,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.tabs == "history"
        ? _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c("Page", {
                attrs: {
                  current: _vm.historyCaseParams.pageIndex,
                  total:
                    _vm.historyCaseParams.total >
                    _vm.historyCaseParams.pageSize * 10
                      ? _vm.historyCaseParams.pageSize * 10
                      : _vm.historyCaseParams.total,
                  "page-size": _vm.historyCaseParams.pageSize,
                },
                on: {
                  "update:current": function ($event) {
                    return _vm.$set(_vm.historyCaseParams, "pageIndex", $event)
                  },
                  "on-change": _vm.getMultiplePeopleCaseHistoryList,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("c-new-multiple-people-case", {
        ref: "newMultiplepeopleCase",
        attrs: {
          battleCaseList: _vm.mpCaseList.battleCaseList,
          mpcCaseSettings: _vm.mpCaseList.mpcCaseSettings,
          caseData: _vm.mpCaseList.caseData,
        },
        on: { createNewCase: _vm.createNewMultiplepeopleCase },
        model: {
          value: _vm.new_multiplePeople_cases_show,
          callback: function ($$v) {
            _vm.new_multiplePeople_cases_show = $$v
          },
          expression: "new_multiplePeople_cases_show",
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "450rem",
            closable: false,
          },
          model: {
            value: _vm.multiplePeople_cases_rules_show,
            callback: function ($$v) {
              _vm.multiplePeople_cases_rules_show = $$v
            },
            expression: "multiplePeople_cases_rules_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "多人开箱说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.multiplePeople_cases_rules_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(" 1. 合开状态达标才会进行开箱。"),
                  _c("br"),
                  _vm._v(" 2. 开箱后立即进入开箱饰品抽选环节。"),
                  _c("br"),
                  _vm._v(" 3. 有份额的玩家皆自动参加抽选。"),
                  _c("br"),
                  _vm._v(" 4. 玩家的抽选概率（%）等于份额占比（%）。 "),
                  _c("br"),
                  _vm._v(" 5. 当箱子饰品开出后，仅抽选1位玩家获得所有饰品。"),
                  _c("br"),
                  _vm._v(" 6. 未抽中任何饰品的玩家自动获得0.01存入余额。"),
                  _c("br"),
                  _vm._v(
                    " 7. 同开箱局一玩家最高份额占比为 " +
                      _vm._s(
                        Number(
                          _vm.mpcCaseSettings.mpCaseMaximumPercent * 100
                        ).toFixed(2)
                      ) +
                      " % 。"
                  ),
                  _c("br"),
                  _vm._v(" 8. 创建多人开箱1局最多5个盲盒。"),
                  _c("br"),
                  _vm._v(
                    " 9. 创建开箱局总价格最低为 " +
                      _vm._s(parseInt(_vm.mpcCaseSettings.mpCaseMinimumPrice)) +
                      " 元。 "
                  ),
                  _c("br"),
                  _vm._v(
                    " 10. 1份额为开箱局总价格的 " +
                      _vm._s(
                        Number(
                          _vm.mpcCaseSettings.mpCaseMinimumPercent * 100
                        ).toFixed(2)
                      ) +
                      " % 。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 11. 当倒数结束合开未达标，则该局自动关闭，并退还份额。"
                  ),
                  _c("br"),
                  _vm._v(
                    " 12. 合开期间若有下架盲盒，则该局自动关闭，并退还份额。 "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "new-mobile-tableHeader flex flex-ais flex-jcsb" },
      [
        _c(
          "div",
          { staticClass: "tableHeader-item flex flex-center-1 width-1" },
          [_vm._v("局号")]
        ),
        _c(
          "div",
          { staticClass: "tableHeader-item flex flex-center-1 width-2" },
          [_vm._v("合开盲盒")]
        ),
        _c(
          "div",
          { staticClass: "tableHeader-item flex flex-center-1 width-4" },
          [_vm._v("状态")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }